import type { EmailSignatureV2 } from '@components/EmailSignaturev2/types';
import { isEqual } from 'es-toolkit';
import { useEffect, useMemo, useState } from 'react';

function useInitialEmailSignature(
  emailSignature: EmailSignatureV2,
  emailSignatureHasBeenLoaded: boolean,
): { initialEmailSignature: EmailSignatureV2 | null; initialEmailSignatureHasBeenLoaded: boolean } {
  const [initialEmailSignature, setInitialEmailSignature] = useState<EmailSignatureV2 | null>(null);
  const [initialEmailSignatureHasBeenLoaded, setInitialEmailSignatureHasBeenLoaded] =
    useState(false);

  useEffect(() => {
    if (!emailSignatureHasBeenLoaded) {
      return;
    }

    if (!isEqual(emailSignature.updatedAt, initialEmailSignature?.updatedAt)) {
      setInitialEmailSignature(emailSignature);
      setInitialEmailSignatureHasBeenLoaded(true);
    }
  }, [emailSignature, emailSignatureHasBeenLoaded, initialEmailSignature?.updatedAt]);

  return useMemo(
    () => ({
      initialEmailSignature,
      initialEmailSignatureHasBeenLoaded,
    }),
    [initialEmailSignature, initialEmailSignatureHasBeenLoaded],
  );
}

export default useInitialEmailSignature;
